import React from "react";
import { Helmet } from "react-helmet";
import favicon from "../../assets/favicon.ico";

const DEFAULT_KEYWORDS = "eHR,e-HR软件,人事管理软件,人力资源管理软件,人力资源软件,人力资源系统,人力资源管理系统,协同管理软件,办公自动化软件,企业一体化管理平台";
const DEFAULT_TITLE = "大任软件HR saas";
const DEFAULT_DESCRIPTION = "信息化重塑HR的价值,随需定制的灵活人力资源管理平台,推动组织管理变革，为企业目标服务。";
const DEFAULT_OG_TITLE = "大任软件-随需应变的人力资源管理平台";

const SEO = ({ title = DEFAULT_TITLE, description = DEFAULT_DESCRIPTION, ogTitle = DEFAULT_OG_TITLE, keywords = DEFAULT_KEYWORDS }) => {
  return (
    <div>
      <Helmet>
        <link rel="icon" href={favicon} />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords}></meta>
        <meta name="author" content="darensoft"></meta>
        <meta name="renderer" content="webkit|ie-comp|ie-stand" />
        <link href="https://web-site-assets.darensoft.com/css/bootstrap.min.css" rel="stylesheet" type="text/css" />
        <link href="https://web-site-assets.darensoft.com/css/animate.min.css" rel="stylesheet" type="text/css" />
        <link href="https://web-site-assets.darensoft.com/css/boxicons.min.css" rel="stylesheet" type="text/css" />
        <link href="https://web-site-assets.darensoft.com/css/flaticon.css" rel="stylesheet" type="text/css" />
        <script type="text/javascript">
          {`var _hmt = _hmt || []; 
          (function() {
            var hm = document.createElement("script");
            hm.src = "https://hm.baidu.com/hm.js?b7760058a759635c7f463de978f71a85";
            var s = document.getElementsByTagName("script")[0]; 
            s.parentNode.insertBefore(hm, s);
          })();`}
        </script>
      </Helmet>
    </div>
  );
};

export default SEO;
